module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }],
    staticClass: "industry-checker"
  }, [_c('popup', {
    attrs: {
      "value": _vm.value,
      "position": "bottom"
    },
    on: {
      "on-hide": _vm.onHide
    }
  }, [_c('popup-header', {
    attrs: {
      "left-text": "取消",
      "right-text": "确定",
      "title": _vm.title
    },
    on: {
      "on-click-left": _vm.onHide,
      "on-click-right": _vm.onConfirm
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main-content"
  }, [_c('checker', {
    attrs: {
      "max": _vm.max,
      "type": "checkbox",
      "default-item-class": "item-class",
      "selected-item-class": "item-selected",
      "disabled-item-class": "item-disable"
    },
    on: {
      "on-change": _vm.checkChange
    },
    model: {
      value: (_vm.selectedIndustry),
      callback: function($$v) {
        _vm.selectedIndustry = $$v
      },
      expression: "selectedIndustry"
    }
  }, _vm._l((_vm.data), function(item) {
    return _c('checker-item', {
      key: item.industryId,
      attrs: {
        "value": item.industryId + '|' + item.industryNameZhCn,
        "disabled": _vm.disableItem(item)
      }
    }, [_vm._v("\n          " + _vm._s(item.industryNameZhCn) + "\n        ")])
  }), 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2864c52c","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plugin/industry-checker.vue
// module id = 304
// module chunks = 1